import * as React from 'react';
import { IgcDropdownComponent as Component } from 'igniteui-webcomponents';
import type { IgcDropdownComponentEventMap } from 'igniteui-webcomponents';
import { type EventName, createComponent } from '../react-props.js';

/**
 * Represents a DropDown component.
 * @slot target - Renders the dropdown's target element.
 * @slot  - Renders the dropdown list items.
 * @fires igcChange - Emitted when the selected item changes.
 * @fires igcOpening - Emitted just before the dropdown is open.
 * @fires igcOpened - Emitted after the dropdown is open.
 * @fires igcClosing - Emitter just before the dropdown is closed.
 * @fires igcClosed - Emitted after closing the dropdown.
 * @csspart base - The dropdown list wrapper container.
 * @csspart list - The dropdown list element.
 * @class
 */
export const IgrDropdown = /* @__PURE__ */ createComponent({
  tagName: 'igc-dropdown',
  displayName: 'IgrDropdown',
  elementClass: Component,
  react: React,
  events: {
    onChange: 'igcChange' as EventName<
      IgcDropdownComponentEventMap['igcChange']
    >,
    onOpening: 'igcOpening' as EventName<
      IgcDropdownComponentEventMap['igcOpening']
    >,
    onOpened: 'igcOpened' as EventName<
      IgcDropdownComponentEventMap['igcOpened']
    >,
    onClosing: 'igcClosing' as EventName<
      IgcDropdownComponentEventMap['igcClosing']
    >,
    onClosed: 'igcClosed' as EventName<
      IgcDropdownComponentEventMap['igcClosed']
    >,
  },
});

export type IgrDropdown = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrDropdownModule = Component;
